<div class="modal-header border-0 pb-0">
  <h5 class="modal-title">Unsaved Changes</h5>
</div>
<div class="modal-body">
  <p class="mb-0">You have unsaved changes in the form, would you like to save them before leaving the page?</p>
</div>
<div class="modal-footer border-0 justify-content-center gap-2">
  <button type="button" class="btn btn-outline-secondary" (click)="discard()">Discard</button>
  <button type="button" class="btn btn-primary" (click)="save()">Save</button>
</div>
